<template>
  <CFooter>
    <div>
      <a href="https://exportedu.ru" target="_blank">Школа Экспорта</a>
      <span class="ms-1"
        >&copy; {{ new Date().getFullYear() }}</span
      >
    </div>
  </CFooter>
</template>

<script>
export default {
  name: 'AppFooter',
}
</script>
